import React from "react";
import StaticPage from "./StaticPage";

export default function Accessibility() {
  return (
    <StaticPage
      eyebrow="Legal"
      title="Accessibility Statement"
      updated="February 2026"
      testId="page-accessibility"
    >
      <p>
        <strong>Occuthera</strong> is committed to making SenseWise accessible to the widest possible
        audience — including students, educators, and clinicians with disabilities.
      </p>

      <h2>Our commitment</h2>
      <p>We design and build SenseWise to conform with the
        <a href="https://www.w3.org/WAI/standards-guidelines/wcag/" target="_blank" rel="noreferrer"> Web
        Content Accessibility Guidelines (WCAG) 2.1 Level AA</a>. Because SenseWise is used in K-12
        settings, we consider accessibility a core part of our clinical mission, not an add-on.</p>

      <h2>Features that support accessibility</h2>
      <ul>
        <li><strong>Low-stimulation mode</strong> in every screen removes animations and mutes color
          saturation for users who are sensitive to motion or visual input.</li>
        <li><strong>Reduced motion</strong> is honored via the operating-system preference
          <code>prefers-reduced-motion</code>.</li>
        <li><strong>Keyboard navigation.</strong> All interactive elements are reachable and operable
          with a keyboard. A &quot;Skip to main content&quot; link is available at the top of every page.</li>
        <li><strong>Visible focus indicators</strong> on all controls.</li>
        <li><strong>Screen readers.</strong> Icon-only buttons carry ARIA labels; page structure uses
          semantic headings and landmarks.</li>
        <li><strong>Color contrast.</strong> Text and interactive elements meet or exceed WCAG AA
          contrast ratios.</li>
        <li><strong>Text sizing.</strong> The Service scales cleanly with browser zoom up to 200%.</li>
        <li><strong>Adjustable inputs.</strong> Student PIN entry uses numeric input modes; forms
          expose native validation for assistive tech.</li>
      </ul>

      <h2>Known limitations</h2>
      <p>We continually test and improve. Known limitations at this time include a small number of
        chart components that convey trends primarily through color — an equivalent tabular view is
        always provided alongside every chart. If you encounter an accessibility barrier we have not
        listed here, please let us know.</p>

      <h2>Feedback &amp; assistance</h2>
      <p>If you experience any accessibility barrier while using SenseWise, or if you need this
        information in an alternate format, contact us at
        <a href="mailto:Hello@occuthera.com"> Hello@occuthera.com</a>. We aim to respond within five
        business days.</p>

      <h2>Formal complaints</h2>
      <p>If you are a member of a US K-12 school community and believe you have been unable to access
        educational content because of a disability, you may also file a complaint with the U.S.
        Department of Education Office for Civil Rights at
        <a href="https://www.ed.gov/OCR" target="_blank" rel="noreferrer"> ed.gov/OCR</a>.</p>
    </StaticPage>
  );
}
